// Auto-refactored from translations.js on 2026-08-19
// Locale: ru

const ru = {
  wieMoeglich: { question: 'Как это возможно?', answer: 'Мы переосмыслили цепочку создания стоимости.' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'Путь STIG ROCK',
    fazit: 'Сокращённая цепочка поставок устраняет крупнейшие статьи расходов.',
    fazitBigPre: 'Это позволяет получить скидку до',
    fazitBigValue: '80%',
    steps: [ 'Рудник', 'Гранильная мастерская', 'Сертификация', 'Конечный клиент' ]
  },
  nav: { language: 'Язык', contact: 'Контакт' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'Уникальная возможность',
    subtitle: 'Создание капитала с ориентиром на будущее.',
    description: 'STIG ROCK — это международная платформа, которая предоставляет людям доступ к природным бриллиантам, устойчивому приумножению капитала и уникальному сообществу.',
    scroll: 'Прокрутите, чтобы узнать больше'
  },
  disclaimer: {
    overline: 'Правовая информация',
    title: 'Disclaimer',
    paragraphs: [
      'Данная презентация носит исключительно информационный характер и не является финансовой, инвестиционной или налоговой консультацией.',
      'STIG ROCK не является финансовым продуктом, а относится к природным Diamond как к материальным активам.',
      'Гарантии в отношении динамики стоимости, прибыли или доходности не предоставляются. Показатели в прошлом не являются гарантией результатов в будущем.',
      'Все расчеты, связанные с комиссионными вознаграждениями, приведены исключительно в качестве примера и также не являются гарантией.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'ПОСТРОЕНО', 'НА СТРУКТУРЕ' ],
    body: 'STIG Group — это международный холдинг, основанный на принципах прозрачности, ответственности и долгосрочной ценности. Каждый бренд, проект и партнерство следуют единому стандарту — без компромиссов и исключений.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'ПОСТРОЕНО', 'НА СТРУКТУРЕ' ],
        body: 'STIG Group — это международный холдинг, основанный на принципах прозрачности, ответственности и долгосрочной ценности. Каждый бренд, проект и партнерство следуют единому стандарту — без компромиссов и исключений.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'МИР', 'ЭКСКЛЮЗИВНЫХ DIAMOND' ],
        body: 'STIG ROCK — это современная концепция STIG Group, объединяющая высококачественные Diamond с сертификацией GIA, прозрачные структуры и эксклюзивный клиентский сервис. Четкие планы решений, профессиональное исполнение и международный масштаб.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'МЕЖДУНАРОДНАЯ', 'ТОРГОВЛЯ DIAMOND' ],
        body: 'Stig International входит в состав STIG Group и специализируется на международной торговле Diamond с сертификацией GIA. Фокус на качестве, доверии и современных торговых структурах с глобальными партнерами.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'ОТВЕТСТВЕННОСТЬ', 'С САМОГО ИСТОКА' ],
        body: 'Ethical Mines выступает за ответственную добычу, отслеживаемое происхождение и бесконфликтные Diamond. От рудника до рынка — полная документация для обеспечения прозрачности, честности и долгосрочной ответственности на всей цепочке поставок.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Бриллианты',
    stigDrawback: 'Реальное средство сбережения',
    overline: 'Возможности',
    title: 'Пути создания капитала',
    subtitle: 'Сравнение традиционных методов.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex или крипто',
        drawback: 'высокая спекулятивность, непредсказуемость, сложность'
      },
      {
        tag: 'Акции',
        name: 'Биржевая торговля',
        drawback: 'риск волатильности, необходимость знаний, затраты времени'
      },
      {
        tag: 'Крипто',
        name: 'Трейдинг',
        drawback: 'волатильность, регуляторные риски, уязвимости безопасности'
      }
    ]
  },
  chance: {
    overline: 'Diamond',
    title: 'Недооцененный шанс',
    body: 'Diamond на протяжении многих лет остаются одним из самых стабильных и перспективных видов инвестиций, однако до сих пор лишь немногие использовали этот потенциал.',
    callout: 'С STIG ROCK мы впервые открываем доступ к этим исключительным возможностям для каждого.'
  },
  wertentwicklung: {
    overline: 'Динамика стоимости 1995 — 2025',
    title: 'История истинной ценности.',
    usd: 'Доллар США',
    usdValue: '-49%',
    diamond: 'Diamond',
    diamondValue: '+185%',
    note: 'Развитие с 1995 по 2025'
  },
  hauptgruende: {
    overline: 'Основные причины',
    title: 'Шесть причин выбрать Diamond',
    lead: 'Diamond — это реальные активы, которые существуют независимо от валют и финансовых систем, сохраняя свою ценность веками.',
    items: [
      {
        n: '01',
        title: 'Кризисоустойчивая стабильность',
        body: 'Гарантия материального актива. Независимость от валют и финансовых систем.'
      },
      {
        n: '02',
        title: 'Абсолютная мобильность',
        body: 'Компактность, легкость в хранении и транспортировке.'
      },
      {
        n: '03',
        title: 'Диверсификация и дефицит',
        body: 'Ограниченность предложения и природная уникальность.'
      },
      { n: '04', title: 'Долгосрочный рост', body: '+185% с 1995 года.' },
      {
        n: '05',
        title: 'Прозрачность и эксклюзивность',
        body: 'Гарантия системы 4 C: Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'Резерв королевских домов',
        body: 'Даже монаршие семьи используют Diamond как резерв благосостояния.'
      }
    ]
  },
  markt: {
    overline: 'Объем рынка',
    title: '99 — 108 Mrd. USD',
    sub: 'Объем торговли в 2025 году',
    forecast: 'Прогноз до ~2032 / 2034: ок. 140 – 168 Mrd. USD при умеренном росте (~4 – 5 % в год).',
    source: 'Источник: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — Инновация',
    title: 'Инновация. Впервые в мире.',
    body: 'STIG ROCK — первая платформа в мире, позволяющая людям получать пассивный доход на рынке Diamond в дополнение к росту их стоимости.',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, VAE',
      'Рег. номер DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: 'О компании',
    titleLines: [ 'МЕЖДУНАРОДНАЯ', 'СТРУКТУРА', 'ЧЕТКОЕ ВИДЕНИЕ' ],
    body: 'STIG ROCK была основана, чтобы сделать рынок Diamond более прозрачным, современным и ориентированным на клиента — с акцентом на доверие, безопасность и долгосрочную структуру.'
  },
  sicherheit: {
    overline: 'Качество и безопасность',
    title: 'Gemological Institute of America',
    body: 'Сертифицированная экспертиза ваших Diamond. Магистр Томас Адлер из GIA оценивает каждый камень с высочайшей точностью и многолетним опытом — надежная оценка стоимости для нашей компании и клиентов.',
    transparency: 'Каждый Diamond соответствует строжайшим стандартам качества, проходит проверку и сертификацию в ведущих организациях. Каждый камень уникален и имеет индивидуальный сертификат.'
  },
  plaene: {
    overline: 'Solution Pläne (SP)',
    title: 'Уникальная инновация продукта',
    sub: 'Шесть уровней Solution Pläne — от $1K до $100K+, каждый с растущей скидкой в месяц и за весь срок действия.',
    recommended: 'Популярно',
    oneYear: '1 год',
    rowLabels: {
      delivery: 'Срок поставки',
      price: 'Цена продукта',
      carat: 'ct',
      monthly: 'Скидка (месяц)',
      totalDiscount: 'Скидка (всего)',
      duration: 'Срок'
    },
    headers: {
      plan: 'План',
      from: 'От',
      carat: 'ct',
      monthly: 'Скидка / мес',
      total: 'Скидка итого',
      duration: 'Срок'
    },
    duration: '1 год',
    footnote: 'Все цены указаны без гарантии и зависят от качества, спроса и текущей рыночной ситуации. Планы Solution также возможны на 2 года.'
  },
  plaeneVIP: {
    overline: 'Solution Pläne + VIP-пакет',
    title: 'Больше преимуществ с VIP-Paket',
    sub: 'Объедините свой Solution Plan с VIP-Paket и получите дополнительные ценовые преимущества до 3%. Таким образом вы увеличите общую скидку и обеспечите себе ещё более выгодные условия.',
    rowLabels: {
      delivery: 'Срок поставки',
      price: 'Цена продукта',
      carat: 'ct',
      monthly: 'Скидка (месяц)',
      totalDiscount: 'Скидка (всего)',
      vip1: 'VIP-пакет 1 (+1%)',
      vip2: 'VIP-пакет 2 (+2%)',
      vip3: 'VIP-пакет 3 (+3%)'
    },
    footnote: 'Все цены указаны без гарантии и зависят от качества, спроса и текущей рыночной ситуации.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'Больше преимуществ с VIP-Paket',
    sub: 'Объедините свой Solution Plan с VIP-Paket и получите дополнительные ценовые преимущества до 3%. Таким образом вы увеличите общую скидку и обеспечите себе ещё более выгодные условия.',
    options: [
      {
        key: 'deliver',
        title: 'Больше преимуществ с VIP-Paket',
        body: 'Получение Diamond (ct) по цене вашего DS-Plan*'
      },
      {
        key: 'sellToUs',
        title: 'Продажа нам',
        body: 'Вы можете продать свои Diamond нам по цене покупки, которую вы оплатили.'
      },
      {
        key: 'sellThirdParty',
        title: 'Продажа третьим лицам',
        body: 'Вы можете перепродать свои Diamond на свободном рынке.'
      }
    ],
    footnote: '*DS-Plan означает Solution план.'
  },
  tradWeg: {
    overline: 'Традиционная торговля',
    title: 'Традиционный путь',
    sub: 'Прежде чем Diamond попадет к конечному клиенту, возникают значительные торговые наценки на этапах посредников, оптовой и розничной торговли по сравнению с ценой необработанного камня из рудника.',
    steps: [
      { title: 'Рудник', subtitle: 'Необработанные Diamond' },
      { title: 'Посредник', subtitle: 'Закупка сырья' },
      { title: 'Огранка', subtitle: 'Превращение в ювелирные камни' },
      { title: 'Сертификация', subtitle: 'в признанных институтах, таких как GIA' },
      { title: 'Алмазная биржа', subtitle: 'Продажа оптовикам' },
      { title: 'Оптовая торговля', subtitle: 'Продажа в розницу' },
      { title: 'Розничная торговля', subtitle: 'напр. ювелирные магазины' },
      { title: 'Клиент', subtitle: 'Покупка Diamond' }
    ]
  },
  stigWeg: {
    overline: 'STIG INTERNATIONAL GEMSTONE FZCO',
    title: 'The Dual-Purchase System',
    sub: 'One purchase. Two diamonds. Double value creation.',
    duration: '1 Purchase = 2 Diamonds = Double Value Creation',
    centerBig: '5',
    centerCaption: 'Example: $10,000 purchase = $20,000 total value',
    cycle: [
      {
        n: '1.',
        title: 'Customer Purchase',
        body: 'Customer buys a diamond with processing time, e.g. $10,000.'
      },
      {
        n: '2.',
        title: 'Dual Assignment',
        body: 'Instant and simultaneous: 1 rough diamond for the customer — 100 % their property. 1 rough diamond for the company — financed from the profit.'
      },
      {
        n: '3.',
        title: 'Value Creation',
        body: 'Combined finished sale value of both diamonds: $20,000 — in the portfolio.'
      },
      {
        n: '4.',
        title: 'Active Trading',
        body: 'The company diamond is immediately processed and traded.'
      },
      {
        n: '5.',
        title: 'Further Revenue',
        body: 'Profits flow into mining licenses, the extraction of rough diamonds and the purchase — STIG Ethical Mines.'
      }
    ],
    steps: [
      { title: 'Mine', subtitle: 'Rough diamonds' },
      { title: 'Cutting', subtitle: 'through our partners' },
      { title: 'Certification', subtitle: 'through recognised institutes' },
      { title: 'End customers', subtitle: 'Purchase & discount credits' }
    ],
    footnote: 'Rough diamond: STIG Ethical Mines · Refinement to sale: STIG International Gemstone FZCO'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'VIP-пакеты',
    sub: 'Действуют 12 месяцев на все оформленные вами планы Solution. В зависимости от пакета: от +1% до +3% дополнительной скидки',
    cardKicker: 'дополнительно – на все',
    cardKicker2: 'Solution планы',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'Скидки превращаются в сбережения',
      body: 'Ежемесячная экономия вместо ежемесячных расходов. Скидки формируют накопления, которые оплачивают именно то, за что вы обычно платите из собственного кармана.',
      line1Label: 'DS-Plan от',
      line1Value: '$5.000',
      line2Label: 'мес. скидка',
      line2Value: '3%',
      line3Label: 'VIP-пакет 3',
      line3Value: '+3%',
      resultLabel: 'мес. сбережения',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'Как это возможно?',
    title: 'Мы переосмыслили цепочку создания стоимости.',
    traditionalTitle: 'Традиционный путь',
    traditionalSteps: [
      'Рудник — Необработанные Diamond',
      'Посредник — Закупка',
      'Огранка — Шлифовка',
      'Сертификация (GIA)',
      'Алмазная биржа — Опт',
      'Оптовая торговля → Розница',
      'Ювелиры → Конечный клиент'
    ],
    traditionalNote: 'Прежде чем Diamond попадет к клиенту, возникают значительные наценки на этапах посредников, опта и розницы.',
    stigTitle: 'Путь STIG ROCK',
    stigSteps: [
      'Прямая закупка — Сырье из рудника',
      'Огранка и сертификация через партнеров',
      'Продажа конечным клиентам и B2B клиентам',
      'До 4 торговых циклов в год'
    ],
    stigNote: 'Мы разрываем цикл и передаем торговую маржу клиентам в виде скидок — до 4 торговых циклов в течение срока DS-Plan.'
  },
  optionen: {
    overline: 'Ваши возможности',
    title: 'После завершения Solution плана',
    items: [
      { title: 'Доставка', body: 'Diamond (ct) по цене вашего DS-Plan.' },
      { title: 'Продажа нам', body: 'Обратный выкуп по цене вашей покупки.' },
      { title: 'Продажа третьим лицам', body: 'Реализация Diamond на свободном рынке.' }
    ]
  },
  einfacherWeg: {
    overline: 'Планы Solution — уникальная инновация',
    title: 'Простой путь',
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Регистрация',
        body: 'Свяжитесь с вашим рекомендателем и создайте бесплатный аккаунт!'
      },
      { n: '02', icon: 'cart', title: 'Покупка продукта', body: 'Доступно уже от $ 250,-' },
      {
        n: '03',
        icon: 'discount',
        title: 'Получение скидок',
        body: 'Получайте ежемесячные скидочные начисления.'
      }
    ]
  },
  business: {
    overline: 'Виды бонусов',
    title: 'Самый простой и справедливый путь.',
    sub: 'Пять видов бонусов — для вашего успешного построения бизнеса.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'До 3 уровней, начиная со ступени Pearl / Ruby.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'От Sapphire — на неограниченную глубину.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'На Infinity Bonus – до 5 уровня · БЕЗ квалификации.'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: '3 пула от мирового товарооборота.'
      },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Единовременный бонус в Diamond (ct).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'Этот бонус выплачивается за каждый новый оформленный DS-Plan в вашей структуре до 3-го уровня. Уровни открываются при минимальных квалификациях.',
    total: 'До 18% Unilevel Bonus',
    levels: [
      {
        level: 'Level 1',
        value: '10%',
        qual: 'с самого начала',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Level 2',
        value: '5%',
        qual: 'со ступени Pearl',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Level 3',
        value: '3%',
        qual: 'со ступени Ruby',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'Начиная со ступени Sapphire, вы квалифицируетесь на наш Infinity Bonus. Вы получаете 3% бонуса. С каждой новой карьерной ступенью процент увеличивается. Если партнер в вашей команде также квалифицирован, вы получаете разницу между рангами.',
    exampleTitle: 'Пример',
    exampleRows: [
      { label: 'Вы — Blue Diamond', value: '12%' },
      { label: 'Ваш партнер — Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'Ваш Infinity Bonus', value: '9%' },
    totalNote: 'Всего до 24% Infinity Bonus на все оформленные планы Solution в вашей команде — на неограниченную глубину.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'С этим бонусом вы получаете выгоду от успеха вашей команды. Вы получаете Matching Bonus в размере 5% от Infinity Bonus ваших партнеров — до 5-го уровня вашей команды.',
    note: 'На все выплаты Infinity Bonus в вашей команде – до 5-го уровня. С самого начала – БЕЗ квалификации.',
    levels: [
      { level: 'Level 1', value: '5%' },
      { level: 'Level 2', value: '5%' },
      { level: 'Level 3', value: '5%' },
      { level: 'Level 4', value: '5%' },
      { level: 'Level 5', value: '5%' }
    ],
    totalPrefix: 'Всего до',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: '3% от мирового товарооборота распределяются поровну между 3 различными пулами. Достигая определенных ступеней карьеры, вы квалифицируетесь в каждый отдельный пул.',
    forever: 'Достигнуто однажды – участие НАВСЕГДА!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'от Blue Diamond' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'от Purple Diamond' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'от Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Итого',
    totalValue: '3%',
    totalSuffix: 'от мирового товарооборота'
  },
  karriere: {
    overline: 'STIG ROCK · Карьерные ступени',
    title: 'Карьерные ступени',
    sub: 'Для достижения соответствующих ступеней учитывается исторический общий оборот (HG). Начиная со ступени Sapphire, он должен быть распределен между несколькими ветками. Для достижения Ruby или выше необходимо иметь минимум двух прямых партнеров с DS-Plan.',
    forever: 'Достигнуто однажды – подтверждено НАВСЕГДА!',
    footnote: 'HV = Исторический общий оборот.',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 пр. партнера', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'Начните вместе с нами',
    title: 'Сейчас — самое подходящее время.',
    body: 'Эта бизнес-модель устанавливает новые стандарты и объединяет все факторы успеха для создания устойчивого и долгосрочного бизнеса. Зарегистрируйтесь сегодня, выберите свой DS-Plan и используйте эту уникальную возможность.',
    hint: 'Свяжитесь с человеком, который пригласил вас на эту презентацию — у него есть ссылка для регистрации.',
    formName: 'Имя',
    formEmail: 'E-Mail',
    formPhone: 'Телефон',
    formSubmit: 'Связаться',
    success: 'Благодарим вас — мы свяжемся с вами лично и конфиденциально.',
    callCta: 'Позвонить',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Правовая информация и Disclaimer',
    disclaimer: 'Данная презентация носит исключительно информационный характер и не является финансовой, инвестиционной или налоговой консультацией. STIG ROCK не является финансовым продуктом, а относится к природным Diamond как к материальным активам. Гарантии в отношении динамики стоимости, прибыли или доходности не предоставляются. Показатели в прошлом не являются гарантией результатов в будущем. Все расчеты, связанные с вознаграждениями, приведены в качестве примера. Возможны изменения контента — свободный перевод (не является официальным).',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, VAE',
    copy: '© 2026 STIG International. Все права защищены.',
    version: 'Версия: DS-12-2025 V3'
  },
  misc: { next: 'Следующий раздел' },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: 'Начиная со ступени Diamond, вы получаете Rang Bonus. Он выплачивается в Diamond (ct) и является единовременным вознаграждением.',
    highlight: 'Diamond (ct) на общую сумму',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  }
};

export default ru;
